import { default as LoadingIcon } from '../../../assets/Icon/LoadingIcon';
import styles from './style.module.scss'; // Import the SCSS module

interface LoaderProps {
  containerClassName?: string;
  className?: string;
  size?: number;
}

const Loader = ({ className, containerClassName, size = 20 }: LoaderProps) => {
  return (
    <div
      className={`
        ${styles.loaderContainer}
        ${containerClassName}
      `}
    >
      <LoadingIcon size={size} />
    </div>
  );
};

export default Loader;
